import { PATH_STAFF } from "./paths";
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthProtect from 'src/components/Auth/AuthProtect';
import DashboardStaffLayout from "src/layouts/DashboardStaffLayout";

// ----------------------------------------------------------------------
const AppStaffRoutes = {
  path: PATH_STAFF.root,
  guard: AuthProtect,
  layout: DashboardStaffLayout,
  routes: [
    // GENERAL
    // ----------------------------------------------------------------------
    // DASHBOARD
    {
      exact: true,
      path: PATH_STAFF.general.root,
      component: lazy(() => import('src/views/StaffDashboardGroup/offer/Offers'))
    },

    // OFFERS
    {
      exact: true,
      path: PATH_STAFF.general.offersDetail.view,
      component: lazy(() => import('src/views/StaffDashboardGroup/offer/offer-detail/OfferView2'))
    },

    // PRE-ORDER
    {
      exact: true,
      path: PATH_STAFF.general.preOrder.root,
      component: lazy(() => import('src/views/StaffDashboardGroup/preorder/PreOrder'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.preOrderDetail.view,
      component: lazy(() => import('src/views/StaffDashboardGroup/preorder/PreOrderView'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.preOrderDetail.edit,
      component: lazy(() => import('src/views/StaffDashboardGroup/preorder/PreOrderEdit'))
    },

    // NOTIFICATIONS
    {
      exact: true,
      path: PATH_STAFF.general.notifications,
      component: lazy(() => import('src/views/CustomerDashboardGroup/notifications/Notifications'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.notificationDetail.view,
      component: lazy(() => import('src/views/CustomerDashboardGroup/notifications/detail/NotificationView'))
    },

    // RETAILER APPLICATION FORM
    {
      exact: true,
      path: PATH_STAFF.general.retailerApplicationForm,
      component: lazy(() => import('src/views/CustomerAppReviewGroup/retailer-application-form/RetailerApplicationForm'))
    },
    // EDIT RETAILER APPLICATION FORM FOR APPROVED STATUS
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.form001,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form001'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.form002,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form002'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.form003,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form003'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.form004,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form004'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.form005,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/Form005'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.formSummary,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/FormSummary'))
    },
    {
      exact: true,
      path: PATH_STAFF.general.editRetailerApplicationForm.formAgreement,
      component: lazy(() => import('src/views/CustomerDashboardGroup/edit-retailer-application-form/FormAgreementTermDistributor'))
    },
  ]
}

export default AppStaffRoutes